<script setup lang="ts">
import { ref } from 'vue';
import useLocale from '../../composables/useLocale';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { faGlobe as faGlobeSolid } from '@fortawesome/pro-solid-svg-icons';
import { storeToRefs } from 'pinia';
import useReaderStore from '../../stores/reader';
import { FontAwesomeIconSizes } from '../../types';
import { useDisplay } from 'vuetify';
import { computed } from 'vue';

library.add([faGlobe, faGlobeSolid]);

type Props = {
  isLanguageMenuVisible: boolean;
  hasLanguages?: boolean;
  showTooltips?: boolean;
  btnSize?: number;
  iconSize?: FontAwesomeIconSizes;
  [key: string]: any; // Pass through any other props
};
const props = withDefaults(defineProps<Props>(), {
  hasLanguages: false,
  showTooltips: true,
  iconSize: 'xl',
  btnSize: 48,
});

const { t } = useLocale();
const { isAudioOnly } = storeToRefs(useReaderStore());
const { smAndDown, sm } = useDisplay();

const icon = computed(() => (props.isLanguageMenuVisible ? 'fa-solid fa-globe' : 'fa-regular fa-globe'));

const languageBtn = ref();

defineExpose({
  languageBtn,
});
</script>

<template>
  <v-btn
    v-if="hasLanguages"
    ref="languageBtn"
    id="language-list-btn"
    data-testid="bp-language-btn"
    color="on-primary"
    v-bind="{
      ...props,
    }"
    variant="text"
    :ripple="false"
    :icon="!isAudioOnly"
    :aria-label="t('label_language_menu')"
    :title="t('label_language_menu')"
    :height="btnSize"
    :width="isAudioOnly && !smAndDown ? '190' : isAudioOnly && sm ? '120' : btnSize"
    :slim="isAudioOnly && smAndDown"
  >
    <div :class="{ 'd-flex flex-column flex-md-row align-center ga-2 overflow-hidden': isAudioOnly }">
      <FontAwesomeIcon :size="iconSize" :icon="icon"></FontAwesomeIcon>
      <span v-if="isAudioOnly" class="text-truncate" :class="smAndDown ? 'text-body-2 w-100' : 'text-body-1'">{{
        t('label_language')
      }}</span>
    </div>
    <v-tooltip :disabled="!showTooltips" activator="parent" location="top" :text="t('label_language_menu')" />
  </v-btn>
</template>

<style scoped lang="scss"></style>
